import { api, makeApiRequest } from './_init'

/**
 * Sentinel v2 API client.
 *
 * The frontend NEVER talks to the Sentinel service directly — every call goes
 * through the trusted Client API (fd-client-api), which injects the tenant
 * headers (X-Client-Id / X-Client-Email) and owns the conversation_id. Auth
 * (Authorization + X-Preferred-Partner-Id) is attached by ./_init.js.
 *
 *   POST   /sentinel/ask                 — ask a question / follow-up
 *   GET    /sentinel/conversations       — history list
 *   GET    /sentinel/conversations/{id}  — resume a conversation
 *   POST   /sentinel/crm/export          — send a turn's audience to a CRM
 *   GET    /sentinel/saved               — list saved questions
 *   POST   /sentinel/saved               — save a question { name, question }
 *   DELETE /sentinel/saved/{id}          — delete a saved question
 */
const sentinelV2Api = {
  ask: async ({ question, conversationId = null, signal = null }) => {
    return await makeApiRequest(api, 'post', '/sentinel/ask', { question, conversation_id: conversationId }, { signal })
  },

  fetchConversations: async () => {
    return await makeApiRequest(api, 'get', '/sentinel/conversations')
  },

  fetchConversation: async (conversationId) => {
    return await makeApiRequest(api, 'get', `/sentinel/conversations/${conversationId}`)
  },

  sendTurnToCRM: async ({ crm_name, secret_id, container_name, conversationId, turnIndex, ids }) => {
    const params = new URLSearchParams()
    params.append('crm_name', crm_name)
    params.append('secret_id', secret_id)
    params.append('container_name', container_name)
    return await makeApiRequest(api, 'post', `/sentinel/crm/export?${params.toString()}`, {
      conversation_id: conversationId,
      turn_index: turnIndex,
      ids: ids || [],
    })
  },

  // Saved questions — curated favourites; a saved question re-runs through /ask.
  fetchSaved: async () => {
    return await makeApiRequest(api, 'get', '/sentinel/saved')
  },

  saveQuestion: async ({ name, question }) => {
    return await makeApiRequest(api, 'post', '/sentinel/saved', { name, question })
  },

  deleteSaved: async (id) => {
    return await makeApiRequest(api, 'delete', `/sentinel/saved/${id}`)
  },
}

export default sentinelV2Api
